export const classNames = (...classes: string[]) => classes.filter(Boolean).join(' ');

export const formatDate = (date: Date) => {
  return `${(date.getDate() < 10 ? 0 : '')}${date.getDate()}/${((date.getMonth() + 1) < 10 ? 0 : '')}${(date.getMonth() + 1)}/${date.getFullYear()}`;
}

export const formatNumber = (number: any) => number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");